module.exports = __webpack_public_path__ + "img/14_40.9aab880b.png";